import { render, staticRenderFns } from "./zyUpload.vue?vue&type=template&id=618c3f5a&scoped=true"
import script from "./zyUpload.vue?vue&type=script&lang=js"
export * from "./zyUpload.vue?vue&type=script&lang=js"
import style0 from "./zyUpload.vue?vue&type=style&index=0&id=618c3f5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c3f5a",
  null
  
)

export default component.exports